<template>
    <Nav-component v-if="!userStore.user.id"></Nav-component>
    <div :class="{ 'content-wrapper container-xxl p-0': !userStore.user.id }">
        <div :class="{ 'cf-container-fluid': !userStore.user.id }">
            <content-with-sidebar
                v-if="Object.keys(blogDetail).length"
                class="cws-container cws-sidebar-right blog-wrapper"
            >
                <div class="blog-detail-wrapper">
                    <div class="row">
                        <div class="col-lg-10 col-md-12 col-sm-12 mx-auto">
                            <b-card
                                :img-src="blogDetail.blobImage"
                                img-top
                                img-alt="Blog Detail Pic"
                                img-height="200"
                                :title="blogDetail.blogtitle"
                                class="credit_custom_image_card"
                            >
                                <div class="media d-flex align-items-center">
                                    <div class="media-body">
                                        <small class="text-muted mr-25">Written by</small>
                                        <small>
                                            <b-link class="text-body">Creditfixrr</b-link>
                                        </small>
                                        <span class="text-muted ml-50 mr-25">|</span>
                                        <small class="text-muted">{{
                                            blogDetail.createdTime
                                        }}</small>
                                        &nbsp;
                                        <small v-if="can=='can'">
                                        <b-badge
                                            pill
                                            class="mr-75"
                                            variant="badge-light-primary"
                                            style="background:#35b169;color:white;"
                                            v-if="status"
                                        >
                                            Published
                                        </b-badge>
                                        <b-badge
                                            pill
                                            class="mr-75"
                                            variant="badge-light-warning"
                                            style="background:#ff9f43 !important;color:white;"
                                            v-else
                                        >
                                            Draft
                                        </b-badge>
                                        </small>
                                    </div>
                                </div>
                                <div class="my-1 py-25">
                                    <b-link v-for="tag in blogDetail.tags" :key="tag">
                                        <b-badge
                                            pill
                                            class="mr-75"
                                            variant="badge-light-primary"
                                            style="background:#35b169;color:white;"
                                        >
                                            {{ tag }}
                                        </b-badge>
                                    </b-link>
                                </div>
                                <!-- eslint-disable vue/no-v-html -->
                                <div
                                    class="blog-content"
                                    v-html="blogDetail.blogdetails"
                                />
                                <hr class="my-2" />
                                <div
                                    class="d-flex align-items-center justify-content-between"
                                >
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex align-items-center mr-1">
                                            <b-link class="mr-50">
                                                <vue-feather
                                                    type="message-square"
                                                ></vue-feather>
                                            </b-link>
                                            <b-link>
                                                <div class="text-body">
                                                    {{
                                                        blogDetail.comment_count
                                                    }}
                                                    Comments
                                                </div>
                                            </b-link>
                                        </div>
                                    </div>
                                    <div class="blog-detail-share d-flex align-items-center justify-content-between">
                                        <div class="d-flex align-items-center justify-content-between" v-if="canEdit">
                                            <router-link
                                                :to="{
                                                    name: 'post-edit',
                                                    params: {
                                                        category: blogDetail.category_slug,
                                                        slug: blogDetail.slug
                                                    }
                                                }"
                                                type="button"
                                                class="mr-1"
                                            >
                                                <b-link class="mr-50">
                                                    <vue-feather type="edit-3" />
                                                </b-link>
                                            </router-link>
                                            <div
                                                class="mr-1"
                                                @click="deletePost"
                                            >
                                                <div class="d-flex align-items-center">
                                                    <b-link class="mr-50">
                                                        <vue-feather type="trash-2" />
                                                    </b-link>
                                                </div>
                                            </div>
                                        </div>
                                    <div
                                        class="dropdown b-dropdown show btn-group"
                                        id="__BVID__935"
                                    >
                                    <button
                                        aria-haspopup="true"
                                        aria-expanded="true"
                                        type="button"
                                        class="btn dropdown-toggle btn-link p-0 dropdown-toggle-no-caret"
                                        id="shareToggle"
                                        v-on:click="toggleShare"
                                    >
                                        <vue-feather type="share-2"></vue-feather>
                                    </button>
                                    <ul role="menu" tabindex="-1" class="dropdown-menu dropdown-menu-right show" aria-labelledby="shareToggle" style="position: absolute; transform: translate3d( -33px, 23px, 0px ); top: 0px; left: 0px; will-change: transform;" x-placement="bottom-end" v-if="showShareOptions">

                                        <li role="presentation" v-for="icon in socialShareIcons" :key="icon">
                                            <a role="menuitem" href="#" target="_self" class="dropdown-item" @click='icon.action' v-html="icon.icon"></a>
                                        </li>

                                    </ul>
                                    </div>
                                </div>
                                </div>
                            </b-card>
                        </div>
                        <div
                            class="col-lg-10 col-md-12 col-sm-12 mx-auto mt-1"
                        >
                            <h6 class="section-label mt-25">Comment</h6>
                            <div
                                class="card"
                                v-if="blogDetail.comments.length > 0"
                                v-for="(comment, index) in blogDetail.comments"
                                :key="index"
                            >
                                <div class="card-body">
                                    <div class="media">
                                        <div class="avatar mr-75">
                                            <div
                                                class="avatar-content avatar-xl"
                                                :class="getRandomBackgroundClass"
                                                height="38"
                                                width="38"
                                            >
                                                <span class="avatar-content">{{
                                                    comment.commentorAbv
                                                }}</span>
                                            </div>
                                        </div>
                                        <div class="media-body">
                                            <h6 class="font-weight-bolder mb-25">
                                                {{ comment.from_user }}
                                            </h6>
                                            <p class="card-text">
                                                <small class="text-muted">{{
                                                    comment.published_at
                                                }}</small>
                                            </p>
                                            <p class="card-text">
                                                {{ comment.comment }}
                                            </p>
                                            <a href="#" @click.prevent="deleteComment(comment.id)" v-if="can=='can'" >
                                                delete
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card" v-else>
                                <div class="card-body">
                                    <div class="media">No Comments</div>
                                </div>
                            </div>
                        </div>
                        <b-col class="col-lg-10 col-md-12 col-sm-12 mx-auto mt-2" v-if="closure">
                            <h6 class="section-label">Leave a Comment</h6>
                            <div class="card">
                                <div class="card-body">
                                    <div class="media">
                                        <span>Click </span>
                                        <a href="/login"> &nbsp;login &nbsp;</a> if you
                                        have an account or
                                        <a href="/register">
                                            &nbsp;Create Account &nbsp;</a
                                        >
                                        to leave a comment.
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col class="col-lg-10 col-md-12 col-sm-12 mx-auto mt-2" v-else>
                            <h6 class="section-label">Leave a Comment</h6>
                            <b-card>
                                <div class="row">
                                    <b-col cols="12" v-if="errorMessage">
                                        {{ errorMessage }}
                                    </b-col>
                                    <b-col cols="12" v-else> </b-col>
                                    <b-col cols="12">
                                        <div class="form-group">
                                            <b-form-textarea
                                                name="textarea"
                                                rows="4"
                                                v-model="userComment"
                                                placeholder="Comment here"
                                            />
                                        </div>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-button
                                            @click="submitComment"
                                            class="mt-1"
                                            v-ripple.400="
                                                'rgba(255, 255, 255, 0.15)'
                                            "
                                            variant="primary"
                                        >
                                            Post Comment
                                        </b-button>
                                    </b-col>
                                </div>
                            </b-card>
                        </b-col>
                    </div>
                </div>
                <template #sidebar class="blog-sidebar py-2 py-lg-0">
                    <div class="blog-search">
                        <div class="input-group input-group-merge relative">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Search here"
                                v-model="searchVal"
                                @keyup="result"
                            />
                            <div class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                    <i data-feather="search"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="blog-recent-posts mt-3" :class="displayer">
                        <h6 class="section-label">Blog Results Posts</h6>
                        <div
                            class="mt-75"
                            v-for="(result, index) in searchResult"
                            :key="index"
                        >
                            <div class="media mb-2">
                                <a href="#" class="mr-2">
                                    <img
                                        class="rounded"
                                        :src="result.blobImage"
                                        width="100"
                                        height="70"
                                        :alt="result.blobImage.slice(6)"
                                    />
                                </a>
                                <div class="media-body">
                                    <h6 class="blog-recent-post-title">
                                        <a
                                            :href="
                                                '/blog/' +
                                                result.category_slug +
                                                '/' +
                                                result.slug
                                            "
                                            class="text-body-heading"
                                            style="font-size: 12px"
                                            >{{ result.title }}</a
                                        >
                                    </h6>
                                    <div
                                        class="text-muted mb-0"
                                        style="font-size: 11px"
                                    >
                                        {{ result.published_at }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="blog-recent-posts mt-3"
                        v-if="Object.keys(relatedPost).length"
                    >
                        <h6 class="section-label">Related Posts</h6>
                        <div
                            class="mt-75"
                            v-for="(recentpost, index) in relatedPost"
                            :key="index"
                        >
                            <div class="media mb-2">
                                <a
                                    :href="
                                        '/blog/' +
                                        recentpost.category_slug +
                                        '/' +
                                        recentpost.slug
                                    "
                                    class="mr-2"
                                >
                                    <img
                                        class="rounded"
                                        :src="recentpost.blobImage"
                                        width="100"
                                        height="70"
                                        :alt="recentpost.blobImage.slice(6)"
                                    />
                                </a>
                                <div class="media-body">
                                    <h6 class="blog-recent-post-title">
                                        <a
                                            :href="
                                                '/blog/' +
                                                recentpost.category_slug +
                                                '/' +
                                                recentpost.slug
                                            "
                                            class="text-body-heading"
                                            style="font-size: 12px"
                                            >{{ recentpost.title }}</a
                                        >
                                    </h6>
                                    <div
                                        class="text-muted mb-0"
                                        style="font-size: 10px"
                                    >
                                        {{ recentpost.createdTime }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="blog-recent-posts mt-3" v-else>
                        <h6 class="section-label">Related Posts</h6>
                        <div class="mt-75">
                            <div class="media mb-2">No related Post</div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <h6 class="section-label mb-1">Categories</h6>
                        <div
                            v-for="(category, index) in arr"
                            :key="index"
                            class="d-flex justify-content-start align-items-center mb-75"
                        >
                            <b-link>
                                <b-avatar
                                    rounded
                                    size="32"
                                    variant="badge-light-primary"
                                    class="mr-75 badge-light-primary"
                                >
                                    <vue-feather type="droplet" icon></vue-feather>
                                </b-avatar>
                            </b-link>
                            <a :href="'/blog/' + category.category_slug">
                                <div class="blog-category-title text-body">
                                    {{ category.category }}
                                </div>
                            </a>
                        </div>
                    </div>
                </template>
            </content-with-sidebar>
        </div>
    </div>
</template>

<script>
import {
    BAvatar,
    BBadge,
    BButton,
    BFormInput,
    BCard,
    BCardText,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormTextarea,
    BFormCheckbox,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BLink,
} from "bootstrap-vue-3";
import { reactive } from "vue"
import Ripple from "vue-ripple-directive";
import ContentWithSidebar from "../../@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue";
import axios from "axios";
import Swal from 'sweetalert2'
import { getRandomBackgroundClass } from '../../utilities/_helpers'
import NavComponent from './NavComponent.vue'
import { useUserStore } from '../../stores/UserStore.js'

export default {
    components: {
        BFormInput,
        BAvatar,
        BLink,
        BCard,
        BFormGroup,
        BInputGroup,
        BInputGroupAppend,
        BBadge,
        BCardText,
        BDropdown,
        BForm,
        BDropdownItem,
        BFormTextarea,
        BFormCheckbox,
        BButton,
        ContentWithSidebar,
        NavComponent,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            search_query: "",
            commentCheckmark: "",
            blogDetail: [],
            blogTitle: "",
            userComment: "",
            socialShareIcons: [
                {
                    icon: `<svg xmlns="http://www.w3.org/2000/svg"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="feather feather-facebook"
                            >
                              <path
                                  d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                              ></path></svg>`,
                    action: this.facebookShare,
                },
                {
                    icon: `<svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18px"
                              height="18px"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="feather feather-twitter"
                          >
                            <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
                          </svg>`,
                    action: this.twitterShare,
                }
            ],
            arr: [],
            relatedPost: {},
            searchVal: "",
            searchfeed: false,
            searchResult: {},
            canEdit: false,
            closure: false,
            errorMessage: null,
            showShareOptions:false,
            can:false,
            status:null,
            userStore: useUserStore(),
        };
    },
    setup(props) {
        return {
            getRandomBackgroundClass: getRandomBackgroundClass,
            baseUrl: baseUrl,
        }
    },
    computed: {
        displayer() {
            return this.searchfeed ? "showresult" : "hideresult";
        },
    },
    created() {
        this.pageData();
    },
    mounted() {},
    methods: {
        toggleShare(){
          if(this.showShareOptions){
            this.showShareOptions = false
          }else{
            this.showShareOptions = true
          }
        },
        result() {
            let params = {
                searchvalue: this.searchVal,
            };
            let n = this;
            const route = this.$router.resolve(
                {
                    name: 'blog-search',
                }
            );
            axios
                .get(route.href, { params })
                .then(({ data }) => {
                    if (!data.false && data.searchResult != null) {
                        n.searchResult = data.searchResult;
                        n.searchfeed = true;
                    } else {
                        n.searchResult = {};
                        n.searchfeed = false;
                    }
                })
                .catch(({ response }) => {
                    // console.error(response)
                });
        },
        facebookShare(e) {
            e.preventDefault();
            let url = window.location.href;
            url = String(url);
            let params = {
                url: url,
                type: "facebook",
            };
            $.ajax({
                type: "post",
                url: "/socialshare",
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                        "content"
                    ),
                },
                data: params,
                success: function (response) {
                    if (!response.error) {
                        window.open(response.shareUrl, "_blank");
                    }
                },
                error: function (error) {
                },
            });
        },
        twitterShare(e) {
            e.preventDefault();
            let url = window.location.href;
            url = String(url);
            let params = {
                url: url,
                type: "twitter",
            };
            $.ajax({
                type: "post",
                url: "/socialshare",
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                        "content"
                    ),
                },
                data: params,
                success: function (response) {
                    if (!response.error) {
                        window.open(response.shareUrl, "_blank");
                    }
                    this.errorMessage = response.message;
                    // toastr.success(response.message, 'success!');
                },
                error: function (error) {
                },
            });
        },
        linkedinShare(e) {
            e.preventDefault();
            let url = window.location.href;
            url = String(url);
            let params = {
                url: url,
                type: "linkedin",
            };
            $.ajax({
                type: "post",
                url: "/socialshare",
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                        "content"
                    ),
                },
                data: params,
                success: function (response) {
                    if (!response.error) {
                        window.open(response.shareUrl, "_blank");
                    }
                },
                error: function (error) {
                },
            });
        },
        async pageData() {
            const route = this.$router.resolve(
                {
                    name: 'blog-category-content',
                    params: {
                        category: this.$route.params.category,
                        slug: this.$route.params.slug,
                    },
                }
            );
            const $this = this;
            await axios
                .post(route.href)
                .then(({ data }) => {
                    if(data.error){
                        $this.$router.push({ name: 'blogs' });
                        return;
                    }
                    this.blogTitle = data.blogDetails.blogtitle;
                    this.blogDetail = data.blogDetails;
                    this.arr = data.category;
                    this.relatedPost = data.relatedPosts;
                    this.canEdit = data.can_edit;
                    this.closure = data.closure;
                    this.can = data.auth
                    this.status = data.blogDetails.published
                })
                .catch((error) => {
                    toastr.error("An error occured", "error!");
                });
        },
        submitComment() {
            const $this = this;
            let comment = {
                comment: this.userComment,
                random_id: this.blogDetail.randomId,
            };
            if (_.words(this.userComment).length > 10) {
                const route = this.$router.resolve(
                    {
                        name: 'comment-store',
                    }
                );
                axios.post(
                    route.href,
                    comment
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                    setTimeout(() => {
                        location.reload();
                    }, 4000);
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data, 'Error!');
                });
            } else {
                toastr.error(
                    "The comment should have more than 10 words",
                    "error!"
                );
            }
        },
        deletePost() {
            var result = confirm("Do you Want to delete this post?");
            if (result) {
                //Logic to delete the item
                axios
                    .post("/delete/" + this.blogDetail.randomId, {
                        _method: "delete",
                    })
                    .then(({ data }) => {
                        if (!data.error) {
                            window.location = "/blog";
                        } else {
                            toastr.error("An error occured", "error!");
                        }
                    })
                    .catch((err) => {
                        toastr.error(
                            "An error occured please try again",
                            "error!"
                        );
                    });
            } else {
            }
        },
        deleteComment(id){
            const $this = this;
            Swal.fire({
                title: 'Are you sure ?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.$router.resolve(
                        {
                            name: 'comment-delete',
                            params: {
                                id: id
                            }
                        }
                    );
                    axios.delete(route.href)
                    .then(function(response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        toastr.success(response.data.message, 'Success!');
                        setTimeout(() => {
                            location.reload();
                        }, 4000);
                        return;
                    }).catch(function(error) {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss">
@import "../../../sass/vue/pages/page-blog.scss";
.credit_custom_image_card img{
  height:auto !important;
}
.cf-container-fluid{
    width: 100%;
    padding-right: 30px;
    padding-left: 30px;
    padding-top:100px;
    margin-right: auto;
    margin-left: auto;
}
</style>
